module.exports = __webpack_public_path__ + "static/media/server-redundancy-illustration.657d5c58.svg";